import { EULAprops } from '@usacsmideo/types';

export const EULAInstructions = (props: EULAprops) => {
  return <p className="my-2 text-sm font-light italic">{props.text}</p>;
};
